import { render, staticRenderFns } from "./DemandsCreateEdit.vue?vue&type=template&id=6f03ef90&"
import script from "./DemandsCreateEdit.vue?vue&type=script&lang=js&"
export * from "./DemandsCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./DemandsCreateEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports